import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { getSettings } from '../api/settings';

export default function Maintenance() {
  const { logout } = useAuth();
  const [message, setMessage] = useState('The portal is currently under maintenance. Please check back shortly.');

  useEffect(() => {
    getSettings().then((s) => setMessage(s.maintenanceMessage)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white shadow-md rounded-lg p-8 w-full max-w-md text-center">
        <div className="text-4xl mb-4">🛠️</div>
        <h1 className="text-xl font-semibold text-gray-800 mb-2">Under Maintenance</h1>
        <p className="text-sm text-gray-600 mb-6">{message}</p>
        <button
          onClick={logout}
          className="text-sm text-blue-600 hover:underline"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
